import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendBrandBrief, BackendMutationDeleteBrandBriefArgs } from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteBrandBrief($id: ID!) {
    deleteBrandBrief(id: $id) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteBrandBriefArgs;
type Result = Pick<BackendBrandBrief, 'id'>;

export const deleteBrandBrief = async (variables: Variables): Promise<Result | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
